import { Directive, HostListener, OnDestroy } from '@angular/core';
import { AuthService } from '@app/services/auth.service';
import { HelperService } from '@app/services/helper.service';
import { interval, Subscription } from 'rxjs';
import { environment } from '../../environments/environment';
 
@Directive({
  selector: '[appInactivity]'
})
export class InactivityDirective implements OnDestroy {
  private countdown$: Subscription | null = null;
  private readonly minuteInMilliseconds = 60000;
  private readonly minutes = environment.production ? 45 : 10;
  private lastActivityTime: number = Date.now();
 
  constructor(private auth: AuthService, private helper: HelperService) {
    this.startInactivityTimer();
    this.checkSessionValidity();
    this.listenForVisibilityChange();
  }
 
  @HostListener('click') onClick() { this.resetTimer(); }
  @HostListener('keypress') onKeypress() { this.resetTimer(); }
  @HostListener('scroll') onScroll() { this.resetTimer(); }
  @HostListener('mousemove') onMouseMove() { this.resetTimer(); }
  @HostListener('touchstart') onTouch() { this.resetTimer(); }
 
  private resetTimer() {
    this.lastActivityTime = Date.now();
    this.startInactivityTimer();
  }
 
  private startInactivityTimer() {
    if (this.countdown$) this.countdown$.unsubscribe();
 
    this.countdown$ = interval(this.minuteInMilliseconds).subscribe(() => {
      if (Date.now() - this.lastActivityTime >= this.minutes * this.minuteInMilliseconds) {
        this.helper.logOut();
      }
    });
  }
 
  private checkSessionValidity() {
    const expiresCF = sessionStorage.getItem('expiresCF');
    if (expiresCF && Number(expiresCF) < Date.now()) {
      this.helper.logOut();
    }
  }
 
  private listenForVisibilityChange() {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') this.resetTimer();
    });
  }
 
  ngOnDestroy() {
    if (this.countdown$) this.countdown$.unsubscribe();
  }
}